import Tooltip from 'tooltip.js'

document.querySelectorAll('[data-toggle="tooltip"]').forEach(el => new Tooltip(el, {
    title: el.dataset.title
}))